// FeedMessages.js
import FeedStoryProvider from '../container/FeedStoryProvider.js';
import FeedMessages from '../component/FeedMessages.jsx';

export default FeedStoryProvider(FeedMessages);
